import { ReactNode } from "react";
import { FinallyMigrationBanner } from "components/Auth/FinallyMigrationBanner";
import { ConditionalLink } from "components/conditionalLink";
import { Inkle } from "components/icons/Logos/Inkle";
import { SIGN_UP } from "constants/magicLink";
import { NeedHelp } from "v2/components/onboarding/NeedHelp/NeedHelp";
import SigninBackground from "static/images/SigninBackground.png";

type SigninLayoutProps = {
  children: ReactNode;
};

const SigninTopBar = () => (
  <div className="t-relative t-z-10 t-flex t-w-full t-items-center t-justify-between t-px-8 t-py-5 t-border-0 t-border-b t-border-solid t-border-neutral-10 t-bg-neutral-66 sm:t-border-b-0 sm:t-bg-white">
    <Inkle />
    <div className="t-flex t-items-center t-gap-1.5 t-text-body-sm t-text-text-30 sm:t-hidden">
      Don't have an account?
      <ConditionalLink to={SIGN_UP} target="_self">
        Sign up
      </ConditionalLink>
    </div>
  </div>
);

export const SigninLayout = ({ children }: SigninLayoutProps) => {
  return (
    <div className="t-relative t-flex t-h-screen t-w-screen t-flex-col t-overflow-hidden t-bg-neutral-66 sm:t-bg-white">
      <img
        src={SigninBackground}
        alt=""
        aria-hidden
        className="t-pointer-events-none t-absolute t-inset-0 t-h-full t-w-full t-object-cover t-object-bottom sm:t-hidden"
      />
      <SigninTopBar />
      <FinallyMigrationBanner />
      <div className="t-relative t-flex t-flex-1 t-justify-center t-overflow-y-auto t-px-6 t-py-10 t-items-center sm:t-items-start">
        <div className="t-w-full t-max-w-[740px] t-rounded-3xl t-border t-border-solid t-border-neutral-0 t-bg-surface t-p-12 t-shadow-light-60 sm:t-rounded-none sm:t-border-0 sm:t-bg-transparent sm:t-p-0 sm:t-shadow-none">
          {children}
        </div>
      </div>
      <div className="sm:t-hidden">
        <NeedHelp />
      </div>
    </div>
  );
};
